// 组件
import importImg from '@/components/importImg.vue'
import alterForm from '@/components/alterForm'
// 接口
import { getRoomPolicyPricesCollections, putRoomPolicyPricesFormData, getRoomPolicyPricesEditDetails } from '@/services/rooms.js'
// 其他
import loading from '@/utils/loading.json'
import jsonData from './jsonData'
import constant from '@/utils/constant.js'

export default {
  components: {
    importImg,
    alterForm
  },
  data () {
    return {
      modifyData: {},
      collapseLength: [],
      formData: jsonData.formData
    }
  },
  watch: {
  },
  created () {
    this.init()
  },
  mounted () {
  },
  methods: {
    init () {
      this.collapseLength = [...new Array(this.formData.length).keys()]
      this.$store.state.app.loading = this.$loading(loading)
      getRoomPolicyPricesCollections().then(res => {
        if (res.status === 200) {
        }
      })
      getRoomPolicyPricesEditDetails(this.$route.params.id).then(res => {
        if (res.status === 200) {
          this.modifyData = res.data.room_policy_price
          this.modifyData.images_attributes = this.modifyData.images
        }
      }).finally(() => {
        this.$store.state.app.loading.close()
      })
    },
    formSubmit (data) {
      this.$store.state.app.loading = this.$loading(loading)
      const obj = JSON.parse(JSON.stringify(data))
      const params = {
        room_policy_price: obj
      }
      Object.keys(params.room_policy_price).forEach(res => {
        if (typeof params.room_policy_price[res] === 'boolean') {
          if (params.room_policy_price[res] === true) params.room_policy_price[res] = '1'
          if (params.room_policy_price[res] === false) params.room_policy_price[res] = '0'
        }
      })
      putRoomPolicyPricesFormData(params, this.$route.params.id).then(res => {
        if (res.status === 200) {
          this.$message({
            type: 'success',
            message: this.$t('message.operateSuccess')
          })
          setTimeout(() => {
            this.$router.push({
              name: 'roomPolicyPriceList'
            })
          }, constant.ROUTER_CHANGE_INTERVAL)
        }
      }).finally(() => {
        this.$store.state.app.loading.close()
      })
    }
  }
}
